import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./styles.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>FATCA</h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>
                            Simplified FATCA Compliance for Individuals and
                            Businesses
                        </h3>
                        <p>
                            The{" "}
                            <b> Foreign Account Tax Compliance Act (FATCA)</b>
                            requires U.S. taxpayers and foreign financial
                            institutions to report certain financial accounts
                            and assets held outside the United States. At Serene
                            Tax, we provide expert assistance to ensure you meet
                            your FATCA reporting obligations with ease and
                            accuracy.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>What is FATCA Filing?</h3>
                        <p>
                            FATCA is a federal law designed to combat offshore
                            tax evasion. U.S. individuals with substantial
                            foreign financial assets and foreign institutions
                            with U.S. account holders must comply with FATCA’s
                            reporting requirements. Failure to comply can result
                            in significant penalties.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Who Needs to File FATCA? </h3>
                        <p>
                            <b>1.U.S. Taxpayers:</b>Individuals who meet the
                            asset threshold must report their foreign financial
                            assets on Form 8938 as part of their annual tax
                            return.
                        </p>
                        <p>
                            <b>2.Foreign Financial Institutions (FFIs):</b>
                            FFIs are required to report financial accounts held
                            by U.S. citizens or entities to the IRS.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>Our FATCA Filing Services Include</h3>
                        <p>
                            <b>1.FATCA Assessment</b>
                            <br />
                            We review your financial assets or accounts to
                            determine if FATCA reporting is required.
                        </p>
                        <p>
                            <b>2.Form 8938 Preparation</b>
                            <br />
                            For individuals, we accurately prepare and file Form
                            8938, disclosing foreign financial assets as
                            required.
                        </p>
                        <p>
                            <b>3.FFI Reporting Assistance</b>
                            <br />
                            For foreign institutions, we assist with FATCA
                            registration and compliance to ensure timely
                            reporting to the IRS.
                        </p>
                        <p>
                            <b>4.Penalties and Late Filing Resolution</b>
                            <br />
                            If you’ve missed prior FATCA filings, we guide you
                            through IRS amnesty programs and minimize penalties.
                        </p>
                        <p>
                            <b>5.Ongoing Compliance Support</b>
                            <br />
                            Stay compliant year after year with our continued
                            monitoring and reporting services.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Who Needs to File FATCA? </h3>
                        <p>
                            <b>1.U.S. Taxpayers:</b>Individuals who meet the
                            asset threshold must report their foreign financial
                            assets on Form 8938 as part of their annual tax
                            return.
                        </p>
                        <p>
                            <b>2.Foreign Financial Institutions (FFIs):</b>
                            FFIs are required to report financial accounts held
                            by U.S. citizens or entities to the IRS.
                        </p>
                        <h4>Our FATCA Filing Services Include:</h4>
                        <p>
                            <b>1.FATCA Assessment</b>
                            <br />
                            We review your financial assets or accounts to
                            determine if FATCA reporting is required.
                        </p>
                        <p>
                            <b>2.Form 8938 Preparation</b> <br />
                            For individuals, we accurately prepare and file Form
                            8938, disclosing foreign financial assets as
                            required.
                        </p>
                        <p>
                            <b>3.FFI Reporting Assistance</b> <br />
                            For foreign institutions, we assist with FATCA
                            registration and compliance to ensure timely
                            reporting to the IRS.
                        </p>
                        <p>
                            <b>4.Penalties and Late Filing Resolution</b>
                            <br />
                            If you’ve missed prior FATCA filings, we guide you
                            through IRS amnesty programs and minimize penalties.
                        </p>
                        <p>
                            <b>5.Ongoing Compliance Support</b>
                            <br />
                            Stay compliant year after year with our continued
                            monitoring and reporting services.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>Our FATCA Filing Services Include</h3>
                        <p>
                            <b>1.FATCA Assessment</b>
                            <br />
                            We review your financial assets or accounts to
                            determine if FATCA reporting is required.
                        </p>
                        <p>
                            <b>2.Form 8938 Preparation</b>
                            <br />
                            For individuals, we accurately prepare and file Form
                            8938, disclosing foreign financial assets as
                            required.
                        </p>
                        <p>
                            <b>3.FFI Reporting Assistance</b>
                            <br />
                            For foreign institutions, we assist with FATCA
                            registration and compliance to ensure timely
                            reporting to the IRS.
                        </p>
                        <p>
                            <b>4.Penalties and Late Filing Resolution</b>
                            <br />
                            If you’ve missed prior FATCA filings, we guide you
                            through IRS amnesty programs and minimize penalties.
                        </p>
                        <p>
                            <b>5.Ongoing Compliance Support</b>
                            <br />
                            Stay compliant year after year with our continued
                            monitoring and reporting services.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Benefits of FATCA Filing Services</h3>
                        <p>
                            <b>Avoid Penalties:</b>Non-compliance can result in
                            severe financial penalties and legal consequences.
                        </p>
                        <p>
                            <b>Peace of Mind:</b>
                            Ensure accurate reporting with our expert guidance
                        </p>
                        <p>
                            <b>Save Time:</b>
                            Let us handle the complex requirements while you
                            focus on your goals.
                        </p>
                        <p>
                            <b>Stay Informed</b>
                            Benefit from our up-to-date knowledge of FATCA
                            regulations and changes.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Take the Stress Out of FATCA Filing</h3>
                        <p>
                            Ensure compliance and avoid penalties with{" "}
                            <b>Serene Tax’s FATCA filing services</b>. Whether
                            you’re an individual or a foreign financial
                            institution, we’ll guide you through the process
                            with ease and efficiency.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
